// Formula duration keys are legacy identifiers: 3 months bills monthly, 6 months quarterly.
export const OMEGA3_PLAN_AMOUNTS = Object.freeze({
  '3 months': 24.3,
  '6 months': 56.7,
  '30 days': 27,
  '90 days': 64.8,
});

export const getOmega3PlanAmount = (duration) => OMEGA3_PLAN_AMOUNTS[duration] ?? 0;

// Use only for the Start now button; plan cards keep the original Formula totals.
export const getOmega3CheckoutTotal = (formulaAmount, duration, isSelected) => {
  const omega3Amount = isSelected ? getOmega3PlanAmount(duration) : 0;
  return Number((Math.round(Number(formulaAmount || 0)) + omega3Amount).toFixed(2));
};

export const readOmega3Selection = (storage, quizId) => {
  try {
    const value = JSON.parse(storage.getItem(`omega3-selection:${quizId}`));
    return {
      isSelected: value?.isSelected === true,
      hasAdded: value?.hasAdded === true || value?.isSelected === true,
    };
  } catch {
    return { isSelected: false, hasAdded: false };
  }
};

export const writeOmega3Selection = (storage, quizId, selection) => {
  try {
    storage.setItem(`omega3-selection:${quizId}`, JSON.stringify(selection));
  } catch {
    // Selection remains usable when browser storage is unavailable.
  }
};
